import { Link } from 'react-router-dom';
import AdminLayout from '../components/AdminLayout';
import DashboardHomeExperiencesLayoutTab from './DashboardHomeExperiencesLayoutTab';

/**
 * Controlo do layout da home «Experiências» no app cliente (mesmo conteúdo que o separador no Dashboard).
 */
export default function ExperienciasHomeClienteLayoutPage() {
  return (
    <AdminLayout>
      <div className="bg-white min-h-screen">
        <div className="sticky top-0 z-20 px-6 py-6 border-b border-gray-200 bg-white shadow-sm">
          <nav className="text-sm text-gray-500 mb-1">
            <Link to="/dashboard" className="hover:text-gray-700">
              Home
            </Link>
            {' > '}
            <Link to="/experiencias" className="hover:text-gray-700">
              Experiências
            </Link>
            {' > '}
            <span className="text-gray-800">Home (app cliente)</span>
          </nav>
          <h1 className="text-2xl font-bold text-gray-900">Home Experiências — app cliente</h1>
          <p className="mt-2 text-sm text-gray-600 max-w-3xl">
            Retrato da montagem e da ordem das secções na página Experiências para turistas. As alterações gravam na API e são servidas no{' '}
            <code className="text-xs bg-gray-100 px-1 rounded">GET /api/catalogo/cliente</code>.
          </p>
        </div>
        <DashboardHomeExperiencesLayoutTab />
      </div>
    </AdminLayout>
  );
}
